import type { TierDraft } from './group-tier-helpers';

function firstMinErr(tiers: TierDraft[]): string[] {
  const first = tiers[0];
  if (first && first.min_avg <= 0) return ['Primer tramo debe empezar en ≥ 1'];
  return [];
}

function lastMaxErr(tiers: TierDraft[]): string[] {
  const last = tiers[tiers.length - 1];
  if (last && last.max_avg !== null)
    return ['Último tramo debe ser abierto (∞)'];
  return [];
}

function continuityErr(tiers: TierDraft[]): string[] {
  const errs: string[] = [];
  for (let i = 1; i < tiers.length; i++) {
    const prev = tiers[i - 1];
    const curr = tiers[i];
    if (!prev || !curr) continue;
    if (prev.max_avg === null) {
      errs.push(`Tramo ${i + 1} no puede seguir a uno abierto`);
      continue;
    }
    if (curr.min_avg !== prev.max_avg + 1)
      errs.push(`Gap entre tramos ${i} y ${i + 1}`);
  }
  return errs;
}

function amountErr(tiers: TierDraft[]): string[] {
  const errs: string[] = [];
  for (let i = 0; i < tiers.length; i++) {
    const t = tiers[i];
    if (t && t.amount <= 0) errs.push(`Tramo ${i + 1}: importe > 0`);
  }
  return errs;
}

export function validateGroupTiers(tiers: TierDraft[]): string[] {
  if (!tiers.length) return ['Debe haber al menos un tramo'];
  return [
    ...firstMinErr(tiers),
    ...lastMaxErr(tiers),
    ...continuityErr(tiers),
    ...amountErr(tiers),
  ];
}

export type TierFieldErrors = {
  range: Set<number>;
  amount: Set<number>;
};

function pushIf(set: Set<number>, i: number, cond: boolean): void {
  if (cond) set.add(i);
}

export function tierFieldErrors(tiers: TierDraft[]): TierFieldErrors {
  const range = new Set<number>();
  const amount = new Set<number>();
  const last = tiers.length - 1;
  for (let i = 0; i < tiers.length; i++) {
    const t = tiers[i];
    if (!t) continue;
    pushIf(amount, i, t.amount <= 0);
    const prev = i > 0 ? tiers[i - 1] : undefined;
    pushIf(range, i, i === 0 && t.min_avg <= 0);
    pushIf(
      range,
      i,
      !!prev && prev.max_avg !== null && t.min_avg !== prev.max_avg + 1
    );
    pushIf(range, i, i === last && t.max_avg !== null);
  }
  return { range, amount };
}
